'use client';

import { Radio } from '@pickleballinc/react-ui';
import { usePathname, useRouter, useSearchParams } from 'next/navigation';
import { useState } from 'react';

const FILTER_OPTIONS = [
	{ label: 'All', value: 'all' },
	{ label: 'Scheduled', value: 'scheduled' },
	{ label: 'Unscheduled', value: 'unscheduled' }
];

export const SchedulerFilterRadioGroup = () => {
	const router = useRouter();
	const pathName = usePathname();
	const searchParams = useSearchParams();

	const [selectedValue, setSelectedValue] = useState<string | null>(() => searchParams?.get('status') || 'all');

	const handleChange = (value: string) => {
		setSelectedValue(value);

		const searchParamsFilters = new URLSearchParams(searchParams.toString());
		searchParamsFilters.set('status', value);

		router.push(`${pathName}?${searchParamsFilters.toString()}`);
	};

	return (
		<div className="flex gap-4 pb-6">
			{FILTER_OPTIONS.map((option) => (
				<div key={option.value} onClick={() => handleChange(option.value)} className="flex cursor-pointer items-center gap-2">
					<Radio
						radioTheme="orange"
						type="radio"
						name="status"
						value={option.value}
						checked={selectedValue === option.value}
						className="size-5 cursor-pointer"
						readOnly
					/>

					<p className="font-medium text-gray-700">{option.label}</p>
				</div>
			))}
		</div>
	);
};
